var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sign-up-company"}},[_c('div',{staticClass:"modal",class:_vm.modalIsActive ? 'is-active' : ''},[_c('div',{staticClass:"modal-background",on:{"click":_vm.toggleModal}}),_c('sign-up-company-form-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }